<template>
  <!--玩游戏赚积分-->
  <van-overlay :show="showGameMask" class="mask">
    <div class="content">
      <img
        class="content-title"
        src="../../assets/images/activity/workshop/content-title.png"
      />
      <p class="content-p">这里有相互配对的易损件图案<br/>快来找出它们吧！</p>
      <div class="content-time">
        <span>游戏限时</span>
        <van-count-down
              ref="countDown"
              :time="time"
              format="ss"
              :auto-start="false"
              class="content-timelimit"
              @finish="finish"
            />
        <span>秒</span>
      </div>
      <div class="content-gamebox">
        <div class="gamebox-score">
          <span>已找到</span>
          <span class="score">{{ gameResult }}</span>
          <span>组</span>
        </div>
        <ul class="gamecontent">
          <li v-for="item of gameList" :key="item.id" @click="flip(item)">
            <img
              :src="item.imgUrlfont"
              class="card"
              ref="cardz"
              v-if="item.flag === 'front'"
            />
            <!-- 卡片正面图片  -->
            <img
              :src="item.imgUrlback"
              class="card"
              ref="cardf"
              v-if="item.flag === 'back'"
            />
            <!-- 卡片背面背景  -->
            <img
              :src="item.imgSucc"
              class="card"
              ref="cardsucc"
              v-if="item.flag === 'succ'"
            />
          </li>
        </ul>
        <van-overlay class="game-start" :show="showStartInfo">
          <span class="mask-text"
            >点击翻开卡牌，若两张卡牌翻开后为同一款博世易损件，即可得分。</span
          >
          <div class="submit-btn">
            <van-button type="info" size="normal" class="btn-start" round @click="handleStart"
              >开始游戏</van-button
            >
            <van-button type="info" size="normal" class="btn-close" round @click="handleClose"
              >关 闭</van-button
            >
          </div>
        </van-overlay>
        <van-overlay
          v-if="timeFinished"
          class="game-start"
          :show="timeFinished"
        >
          <span class="mask-text"></span>
        </van-overlay>
      </div>
      <div class="sumbtn" v-if="timeFinished">
        <van-button
          :loading="loading"
          class="imgbtn1"
          type="info"
          size="normal"
          round
          @click="handleAgain"
          ><img
            class="imgbtn"
            src="../../assets/images/activity/workshop/again.png"
        /></van-button>
        <van-button
          :loading="loading"
          class="imgbtn2"
          type="info"
          size="normal"
          round
          @click="handleSubmit"
          ><img
            class="imgbtn"
            src="../../assets/images/activity/workshop/subgrade.png"
        /></van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import activityApi from '@/api/activity'
export default {
  name: 'ActivityWorkshopCollectGame',
  data () {
    return {
      time: 30000,
      showStartInfo: true,
      loading: false,
      ids: [],
      recordList: [],
      gameResult: 0,
      timeFinished: false,
      showGameMask: false,
      gameList: []
    }
  },
  methods: {
    show () {
      this.initData()
      this.showGameMask = true
    },
    close () {
      this.showGameMask = false
    },
    initData () {
      this.gameList = []
      for (let i = 0; i < 16; i++) {
        const pos = i % 8
        this.gameList.push({
          id: i + 1,
          imgUrlfont: require('../../assets/images/activity/workshop/font' + (pos + 1) + '.png'),
          imgUrlback: require('../../assets/images/activity/workshop/back.png'),
          img_sign: pos + 1,
          imgSucc: require('../../assets/images/activity/workshop/succ' + (pos + 1) + '.png'),
          flag: 'back'
        })
      }
      // 初始时打乱图片位置，保证用户每次进来图片位置不一样
      this.randomRender()
    },
    // 倒计时结束
    finish () {
      this.timeFinished = true
    },
    // 开始游戏
    handleStart () {
      this.showStartInfo = false
      setTimeout(() => {
        this.$refs.countDown.start()
      }, 1000)
    },
    handleClose () {
      this.showGameMask = false
    },
    // 随机排列图片位置
    randomRender () {
      let imgs = this.gameList
      let results = []
      results = imgs.sort(() => {
        return Math.random() > 0.5 ? -1 : 1
      })
      this.gameList = results
    },
    // 点击卡片事件
    flip (item) {
      // 判断是否点击开始游戏
      if (this.showStartInfo === false) {
        var result = this.recordList.find((value) => {
          if (value.id === item.id) {
            return true
          }
        })
        if (result) {
          return false
        } else if (item !== this.ids[0]) {
          item.flag = 'front'
          this.ids.push(item)
        }
        if (this.ids.length === 2) {
          if (this.ids[0].img_sign === this.ids[1].img_sign) {
            this.gameList.forEach((item) => {
              if (item.img_sign === this.ids[0].img_sign) {
                item.flag = 'succ'
              }
            })
            this.recordList.push(this.ids[0])
            this.recordList.push(this.ids[1])
            this.ids.splice(0, 2)
            this.gameResult++
            if (this.gameResult === 8) {
              this.$refs.countDown.pause()
              this.timeFinished = true
            }
          }
        } else if (this.ids.length > 2) {
          // 若前两张未配对成功 当翻开三张牌时 让前两张翻过去 并将数组中这俩卡片数据删除
          let x = this.ids.find((value, index, arr) => {
            if (index < 2) {
              return arr[index] === item
            }
          })
          if (x === undefined) {
            for (let i = 0; i < this.ids.length - 1; i++) {
              this.gameList.forEach((item) => {
                if (item.id === this.ids[i].id) {
                  item.flag = 'back'
                }
              })
            }
            this.ids.splice(0, 2)
          } else {
            this.ids.splice(this.ids.length - 1, 1)
          }
        }
      }
    },
    // 再试一次
    handleAgain () {
      this.timeFinished = false // 再试一次和提交成绩按钮消失
      this.showStartInfo = true // 显示开始游戏按钮
      this.$refs.countDown.reset() // 重置倒计时
      this.ids = []
      this.recordList = []
      this.gameResult = 0
      this.gameList.forEach((item) => {
        item.flag = 'back'
      })
      this.randomRender()
    },
    // 提交成绩
    handleSubmit () {
      this.$dialog.confirm({
        message: '成绩提交后得分及积分获得不可更改累积，是否确认提交？'
      }).then(() => {
        this.submitGameResult()
      }).catch(() => {
        console.log('error')
      })
    },
    submitGameResult () {
      this.$toast.loading({
        message: '成绩提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi
        .workshopCollectTask3Submit({ gameResult: this.gameResult })
        .then((response) => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            // 提交成功后跳转到活动主页面
            this.$emit('onSubmit', true)
            this.close()
          } else {
            this.$toast.loading({
              type: 'fail',
              duration: 1000,
              message: response.data.resultMsg
            })
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.mask {
  width: 100%;
  height: 100%;
}
.content {
  position: relative;
  width: 100%;
  height: 900px;
  .content-title {
    position: absolute;
    width: 169px;
    height: 41px;
    top: 25px;
    left: 50%;
    transform: translateX(-50%);
  }
  .content-p {
    position: absolute;
    top: 75px;
    width: 100%;
    text-align:center;
    color: rgb(255, 255, 255);
    font-size: 16px;
    line-height: 26px;
  }
  .content-time {
    position: absolute;
    width: 120px;
    height: 20px;
    top: 130px;
    left: 50%;
    transform: translateX(-50%);
    color: rgb(255, 255, 255);
    font-size: 18px;
    .content-timelimit {
      font-size: 24px;
      color: rgb(255, 246, 3);
      display: inline-block;
    }
  }
  .content-gamebox {
    position: absolute;
    width: 336px;
    height: 400px;
    top: 160px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url(../../assets/images/activity/workshop/gameBox.png);
    background-size: 100% 100%;
    .gamebox-score {
      margin: 10px 0;
      text-align: center;
      color: rgb(189, 89, 46);
      font-size: 14px;
      span {
        line-height: 28px;
        height: 28px;
      }
      .score {
        margin: 0 4px;
        font-size: 20px;
        font-weight: 700;
      }
    }
    .game-start {
      position: absolute;
      width: 303px;
      height: 313px;
      top: 51px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 20px;
      .mask-text {
        position: absolute;
        text-align: center;
        padding: 8px 36px;
        color: rgb(255, 255, 255);
        font-size: 14px;
        line-height: 24px;
      }
      .submit-btn {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        .van-button {
          width: 120px;
          height: 40px;
          line-height: 40px;
          background: rgb(227, 106, 91);
          border: none;
          border-radius: 5px;
          .van-button__text {
            font-size: 20px;
          }
        }
        .btn-close {
          margin-top: 16px;
        }
      }
    }
    .gamecontent {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      position: absolute;
      width: 271px;
      top: 70px;
      bottom: 55px;
      left: 50%;
      transform: translateX(-50%);
      li {
        width: 62px;
        height: 65px;
        position: relative;
        cursor: pointer;
        perspective: 800px;
        .card {
          width: 62px;
          height: 65px;
          left: 0;
          position: absolute;
          transition: 0.3s ease-in-out;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }
      }
    }
  }
  .sumbtn {
    position: fixed;
    bottom: 40px;
    width: 100%;
    text-align: center;
    .imgbtn1 {
      background-color: rgb(138, 169, 177);
    }
    .imgbtn2 {
      background-color: rgb(227, 106, 91);
    }
    .van-button {
      width: 120px;
      height: 40px;
      line-height: 40px;
      border: none;
      border-radius: 5px;
      margin: 0px 16px;
      .imgbtn {
        width: 90px;
        height: 19px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto auto;
      }
    }
  }
}
</style>
